var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("data.transactions_summary")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "filter-container" },
      [
        _c("span", { staticClass: "transTime" }, [
          _vm._v(_vm._s(_vm.$t("merchantAccount.transaction_date")) + ":"),
        ]),
        _c("el-date-picker", {
          staticClass: "mb-10 picker",
          attrs: {
            size: "small",
            format: "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            type: "daterange",
            "range-separator": "~",
            "picker-options": _vm.pickerOptions,
            "start-placeholder": _vm.$t("components.start_date"),
            "end-placeholder": _vm.$t("components.end_date"),
          },
          model: {
            value: _vm.search.times,
            callback: function ($$v) {
              _vm.$set(_vm.search, "times", $$v)
            },
            expression: "search.times",
          },
        }),
        _c(
          "el-button",
          {
            staticClass: "search-btn mb-10",
            attrs: { type: "primary", size: "small", icon: "el-icon-search" },
            on: { click: _vm.handleFilter },
          },
          [_vm._v(_vm._s(_vm.$t("components.search")))]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "monthly-summary" }, [
      _vm._v(" " + _vm._s(_vm.$t("data.total_transaction_details")) + " "),
    ]),
    _c("div", { staticClass: "total" }, [
      _c("div", { staticClass: "total-item" }, [
        _c("div", { staticClass: "total-title" }, [
          _vm._v(_vm._s(_vm.$t("data.collection_amount"))),
        ]),
        _c("div", { staticClass: "total-num" }, [
          _vm._v(
            _vm._s(
              _vm._f("toDivideWithDot")(
                _vm.dateBetweenTransSum.total_payment_amount
              )
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "line" }),
      _c("div", { staticClass: "total-item" }, [
        _c("div", { staticClass: "total-title" }, [
          _vm._v(_vm._s(_vm.$t("data.collection_number"))),
        ]),
        _c("div", { staticClass: "total-num" }, [
          _vm._v(_vm._s(_vm.dateBetweenTransSum.total_payment_count || 0)),
        ]),
      ]),
      _c("div", { staticClass: "line" }),
      _c("div", { staticClass: "total-item" }, [
        _c("div", { staticClass: "total-title" }, [
          _vm._v(_vm._s(_vm.$t("data.collection_commission"))),
        ]),
        _c("div", { staticClass: "total-num" }, [
          _vm._v(
            _vm._s(
              _vm._f("toDivideWithDot")(
                _vm.dateBetweenTransSum.total_payment_commission
              )
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "line" }),
      _c("div", { staticClass: "total-item" }, [
        _c("div", { staticClass: "total-title" }, [
          _vm._v(_vm._s(_vm.$t("data.loan_amount"))),
        ]),
        _c("div", { staticClass: "total-num" }, [
          _vm._v(
            _vm._s(
              _vm._f("toDivideWithDot")(
                _vm.dateBetweenTransSum.total_payout_amount
              )
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "line" }),
      _c("div", { staticClass: "total-item" }, [
        _c("div", { staticClass: "total-title" }, [
          _vm._v(_vm._s(_vm.$t("data.loan_number"))),
        ]),
        _c("div", { staticClass: "total-num" }, [
          _vm._v(_vm._s(_vm.dateBetweenTransSum.total_payout_count || 0)),
        ]),
      ]),
      _c("div", { staticClass: "line" }),
      _c("div", { staticClass: "total-item" }, [
        _c("div", { staticClass: "total-title" }, [
          _vm._v(_vm._s(_vm.$t("data.loan_commission"))),
        ]),
        _c("div", { staticClass: "total-num" }, [
          _vm._v(
            _vm._s(
              _vm._f("toDivideWithDot")(
                _vm.dateBetweenTransSum.total_payout_commission
              )
            )
          ),
        ]),
      ]),
    ]),
    _vm.$store.getters.isPii
      ? _c("div", { staticClass: "tips" }, [
          _c(
            "span",
            [
              _c("svg-icon", {
                staticStyle: { color: "#3855F1" },
                attrs: { "icon-class": "icon-font-warning" },
              }),
            ],
            1
          ),
          _vm._v(_vm._s(_vm.$t("tips.current_time_zone"))),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "tableContainer" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              fit: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.transaction_date"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            scope.row.statistic_date
                              ? scope.row.statistic_date.split("00:00:00")[0]
                              : scope.row.statistic_date
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.collection_amount"),
                prop: "payment_amount",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.payment_amount)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.collection_number"),
                prop: "payment_count",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.payment_count))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.collection_commission"),
                prop: "payment_commission_split",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.payment_commission
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.loan_amount"),
                prop: "payout_amount",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(scope.row.payout_amount)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.loan_number"),
                prop: "payout_count",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.payout_count))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.loan_commission"),
                prop: "payout_commission_split",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("toDivideWithDot")(
                              scope.row.payout_commission
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            !_vm.listLoading
              ? _c("paginator", {
                  attrs: { "list-query": _vm.listQuery },
                  on: { "paginator-change": _vm.onClickPaginator },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }